

exports.__esModule = true;
exports.$xoErrorDirective = undefined;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _uiRouter = require('uiRouter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoErrorDirective = exports.$xoErrorDirective = _squid.$Component.extend('$xoErrorDirective', {
    tag: 'xo-error',
    template: _template2['default'],
    lifecycle: {
        enter: function enter() {
            if (_uiRouter.$state.params.code === 'ADDRESS_ERROR') {
                return _uiRouter.$state.go('checkout.error.invalidAddressError');
            }
            return _uiRouter.$state.go('checkout.genericError');
        }
    }
});

angular.value("$xoErrorDirective", $xoErrorDirective);
_squid.$Component;

_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-error/directive.js
// module id = ./pages/xo-error/directive.js
// module chunks = 1